import { useTranslation } from 'react-i18next';
import styles from '../PaymentPlan.module.scss';
const DisplayStatus = ({ status }) => {
    const { t } = useTranslation();
    const statusConfig = {
        'T': { labelKey: 'cancelled', className: styles.status_text_aborted },
        'A': { labelKey: 'cancelled', className: styles.status_text_aborted },
        'V': { labelKey: '', className: '' },
        'P': { labelKey: '', className: '' },
        'W': { labelKey: '', className: '' },
    };
    const statusToDisplay = statusConfig[status];
    if (!statusToDisplay) return null;

    return (
        <p className={statusToDisplay.className}>
            {t(statusToDisplay.labelKey)}
        </p>
    );
};

export default DisplayStatus;
